<svc-dialog #dialog [hasActions]="false" [hideCloseButton]="hideCloseButton">
  <div svc-dialog-title>
    {{ title | transloco }}
  </div>

  <div svc-dialog-content class="m-4">
    <p class="text-sm px-2">
      {{ text | transloco }}
    </p>

    <div mat-dialog-actions class="flex justify-end p-2 mt-5">
      <div class="flex gap-2">
        @if (cancelText !== '') {
          <button
            svc-outlined-btn
            type="button"
            id="svc-confirm-dialog-button-cancel"
            (click)="cancel()"
          >
            {{ cancelText | transloco }}
          </button>
        }

        <button
          svc-filled-btn
          type="button"
          id="svc-confirm-dialog-button-confirm"
          (click)="ok()"
        >
          {{ okText | transloco }}
        </button>
      </div>
    </div>
  </div>
</svc-dialog>
